import { getTheme, Icon, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { BwjPalette } from '../../app-core/app-theme';

export interface IAppHeaderButtonProps {
  icon: string;
  ariaDescription: string;
  onClick: () => void;
}

const getStyleClasses = (theme: ITheme) => {
    const root: IStyle = {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'block',
      height: '7em',
    };

    const button: IStyle = {
      all: 'unset',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      textTransform: 'uppercase',
      fontWeight: 700,
      color: theme.palette.themePrimary,
      fontSize: '3em',
      padding: '0 0.35em',

      '&:hover': {
        color: BwjPalette.themeGrey,
        boxShadow: `inset 0 -0.25rem 0 0 ${theme.palette.themePrimary}`,
      },
    };

  return mergeStyleSets({
    root,
    button,
  });
}

export const AppHeaderButton: React.FunctionComponent<IAppHeaderButtonProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);

  return (
    <li className={cs.root}>
      <button
        className={cs.button}
        aria-label={props.ariaDescription}
        onClick={props.onClick}
      >
        <Icon iconName={props.icon} />
      </button>
    </li>
  );
};
